export default __webpack_public_path__ + "static/media/rte-france.989b7ecf.png";